module.exports = __webpack_public_path__ + "static/media/sports-advt.ee414a89.mp4";